import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import { SideNav } from 'components/side-nav'
import PageAnimation from 'components/page-animation'
import { track, useTracking } from 'lib/analytics'
import StoreBreadcrumb from '../store-breadcrumb'

const ContentContainer = ({
  location,
  params,
  categories,
  children,
  storeNavigationCategories,
}) => {
  const tracker = useTracking()
  const activeSlugSet =
    location?.state?.slugSet ?? categories[params?.categorySlug]?.slugSet ?? []
  const hideBreadcrumb = typeof location === 'undefined'

  const trackCategoryClick = (category) => {
    const leafCategory = !category.children || category.children.length == 0
    tracker.trackEvent({
      event: track.storeCategoryClicked,
      storeCategoryName: category.title,
      isLeafCategory: leafCategory,
      storeCategorySlug: category.urlSlug,
      eventLocation: track.EventLocation.SHOP_MINUS_LEFT_NAV,
    })
  }

  return (
    <div>
      {!hideBreadcrumb && (
        <StoreBreadcrumb activeSlugSet={activeSlugSet} className="hidden-xs" />
      )}
      <Row className="mbl">
        <Col className="hidden-xs" sm={3}>
          <SideNav
            activeSlugSet={activeSlugSet}
            categoryTree={storeNavigationCategories}
            onCategoryClick={trackCategoryClick}
          />
        </Col>
        <Col sm={9}>
          <div style={{ position: 'relative' }}>
            <PageAnimation>
              <div key={params?.categorySlug || ''}>{children}</div>
            </PageAnimation>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  categories: state.categories,
  ...ownProps,
})

export default connect(mapStateToProps)(ContentContainer)
